import crudTemplate from "./crudTemplate";
export default function generate(Service) {
  const crud = crudTemplate(Service);
  const state = {
    list: crud.state.list
  };
  const getters = {
    getList: crud.getters.getList
  };

  const actions = {
    getList: crud.actions.getList
  };

  const mutations = {
    setList: crud.mutations.setList
  };
  return {
    state,
    getters,
    actions,
    mutations
  };
}
